<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="customForm" label-width="100px">
            <el-form-item>
                <FieldItem v-for="(field) in fields" :formId="formId" :key="field.fieldId" :field="field" :formData="formData" />
            <!-- <FieldItem v-for="(field) in fields" :key="field.fieldId" :field="field" :formData="formData" /> -->
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSubmit">保存</el-button>
            </el-form-item>
        </el-form>
        <div v-show="false">{{formData2}}</div>
    </div>
</template>

<script>
    import { isEmpty } from 'lodash';
    // import FieldItem from './FieldItem';

    export default {
        // components: {
        //     FieldItem
        // },
        data () {
            return {
                formData: {},
                rules: {}
            };
        },
        props: {
            fields: {
                type: Array,
                required: true
            },
            formId: {
                type: String
            }
        },
        computed: {
            formData2 () {
                let formFields = {};
                this.fields.forEach(element => {
                    if (!isEmpty(element.formField) && isEmpty(this.formData[element.formField])) {
                        if (element.type === 'subform') {
                            this.$set(this.formData, element.formField, []);
                        } else {
                            this.$set(this.formData, element.formField, '');
                        }
                    }
                });
                this._generateRules();

                return formFields;
            }
        },
        methods: {
            _generateRules () {
                this.fields.forEach(element => {
                    if (!isEmpty(element.formField) && isEmpty(this.rules[element.formField])) {
                        let rules = [];
                        // 是否必填
                        rules.push(Object.assign({}, {
                            required: element.options.required,
                            message: `请输入${element.name}`
                        }, this._generateBaseRule(element)));

                        this.$set(this.rules, element.formField, rules);
                    }
                });
            },
            _generateBaseRule (element) {
                let fieldType = element.type;
                let baseRule = {};
                switch (fieldType) {
                case 'text':
                    baseRule.trigger = 'blur';
                    break;
                case 'date':
                    baseRule.trigger = 'change';
                    // baseRule.type = 'date';
                    break;
                default:
                    baseRule.trigger = 'blur';
                    break;
                }
                return baseRule;
            },
            handleSubmit () {
                this.$refs['customForm'].validate((valid) => {
                    if (valid) {
                        this.$emit('formSubmit', this.formData);
                    }
                });
                // console.log(JSON.stringify(this.formData, null, 2));
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/RenderForm/RenderForm.vue